import { MasterDialog } from "#common/Dialog/Dialog"
import { InputFormGrid2 } from "#common/Forms"
import ByAtInfo from "#core/components/RecordMetadata"
import FormInputSelect from "#core/forms/inputs/FormInputSelect"
import { useApi } from "#hooks/useApi"
import { useApiSend } from "#hooks/useApiSend"
import { UseReloadCourses } from "#training/redux/actions"
import { courseIdGet, courseIdPut, coursePost, platformGet } from "#training/services/Api"
import { Button, FormControl, Skeleton, Stack } from "@mui/material"
import Box from "@mui/material/Box"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { useCallback, useEffect, useMemo, useState } from "react"
import { FormProvider, useForm } from "react-hook-form"
import { CourseDialogPlataforma } from "./CourseDialogPlataforma"

const CourseForm = ({ open, setOpen, id, edit = false, curso = {} }) => {
	const params = useMemo(() => ({ id }), [id])
	const { data: datos, loading } = useApi(courseIdGet, {
		autoFetch: id && open,
		params,
	})
	const methods = useForm()
	const reload = UseReloadCourses()
	const [buttonDisabled, setButtonDisabled] = useState(false)
	const [plataforma, setPlataforma] = useState(false)
	const [actualizar, setActualizar] = useState(false)
	const { data: platformsResponse } = useApi(platformGet, {
		autoFetch: open,
		reload: actualizar,
	})

	const methodApi = useMemo(() => (edit ? courseIdPut : coursePost), [edit])

	const handleClose = useCallback(() => {
		setOpen(false)
	}, [setOpen])

	const success = useCallback(() => {
		handleClose()
		reload()
	}, [handleClose, reload])

	const { fetch, cancelar } = useApiSend(methodApi, {
		success,
		end: () => setButtonDisabled(false),
	})
	const {
		register,
		handleSubmit,
		formState: { errors },
		reset,
	} = methods

	const onSubmit = useCallback(
		(data) => {
			setButtonDisabled(true)
			if (edit) {
				const noSend = [
					"created_by_name",
					"updated_by_name",
					"fecha_creacion",
					"colaborador_creador",
				]
				noSend.forEach((e) => delete data[e])
				fetch(datos.id, data)
			} else fetch(data)
		},
		[datos, edit, fetch]
	)

	useEffect(() => {
		if (edit) reset(datos)
		else
			reset({
				id: "",
				nombre: "",
				horas: "",
				plataforma: "",
				plataforma_nombre: "",
				objetivo: "",
				contenido: "",
				link: "",
			})
	}, [datos, edit, open, reset])
	const title = useMemo(() => {
		if (edit) {
			return "Editar Curso"
		}
		return "Crear Curso"
	}, [edit])

	const buttons = useMemo(() => {
		return [
			{
				label: "Cancelar",
				onClick: () => {
					handleClose()
				},
				disabled: buttonDisabled,
			},
			{
				label: title,
				onClick: handleSubmit(onSubmit),
				disabled: buttonDisabled,
			},
		]
	}, [buttonDisabled, handleClose, handleSubmit, onSubmit, title])

	if (id && loading)
		return (
			<MasterDialog
				title={title}
				maxWidth="md"
				open={open}
				onClose={handleClose}
				buttons={buttons}
			>
				<Skeleton variant="rectangular" height={"50vh"} />
			</MasterDialog>
		)
	return (
		<MasterDialog
			title={title}
			maxWidth="md"
			open={open}
			onClose={handleClose}
			buttons={buttons}
		>
			<Box>
				<FormProvider {...methods}>
					<form onSubmit={handleSubmit(onSubmit)}>
						<FormControl sx={{ width: "100%" }}>
							<Grid container spacing={4} columns={12}>
								<InputFormGrid2
									id="nombre"
									label="Nombre curso"
									multiline
									register={register}
									error={errors}
									registerParams={{
										required: true,
										// maxLength: { value: 255, message: "Máximo 255 caracteres " },
									}}
									propsG={{
										xs: 12,
									}}
								/>

								<InputFormGrid2
									id="objetivo"
									label="Objetivo"
									multiline
									register={register}
									error={errors}
									registerParams={{
										required: true,
										// maxLength: { value: 255, message: "Máximo 255 caracteres " },
									}}
									propsG={{
										xs: 12,
									}}
								/>

								<InputFormGrid2
									id="contenido"
									label="Contenido"
									multiline
									register={register}
									error={errors}
									registerParams={{
										required: true,
										// maxLength: { value: 255, message: "Máximo 255 caracteres " },
									}}
									propsG={{ xs: 12 }}
								/>
								<InputFormGrid2
									id="link"
									label="Link"
									register={register}
									// multiline
									registerParams={{
										required: true,
										pattern: {
											value: /^(https?:\/\/)/,
											message: "Link Incorrecto debe empezar con http:// o https://",
										},
									}}
									error={errors}
									propsG={{ xs: 12 }}
								/>

								<InputFormGrid2
									id="horas"
									label="Horas"
									type="number"
									register={register}
									registerParams={{
										pattern: {
											value: /^\d+$/,
											message: "Debe ser un numero",
										},
										min: {
											value: 1,
											message: "horas debe ser mayor 1",
										},
										required: true,
									}}
									error={errors}
									propsG={{ xs: 4 }}
								/>
								<Grid xs={7}>
									<div>
										<Stack direction="row" spacing={2} alignItems="center">
											<FormInputSelect
												id={"plataforma"}
												label={"Plataforma"}
												data={platformsResponse?.platforms}
												dataId="id"
												dataLabel="description"
												rules={{
													required: true,
												}}
											/>
											<Button
												size="small"
												onClick={() => {
													setPlataforma(true)
												}}
											>
												Crear Plataforma
											</Button>
										</Stack>
									</div>
								</Grid>
								{edit && (
									<Grid xs={12}>
										<Stack direction="row" spacing={2}>
											<ByAtInfo
												at={datos?.fecha_creacion}
												name={datos?.creado_por_name}
												title="Creado Por"
											/>
											<ByAtInfo
												at={datos?.updated_at}
												name={datos?.updated_by_name}
												title="Editado Por"
											/>
										</Stack>
									</Grid>
								)}
							</Grid>
						</FormControl>
					</form>
					<CourseDialogPlataforma
						open={plataforma}
						setOpen={setPlataforma}
						actualizar={actualizar}
						setActualizar={setActualizar}
					/>
				</FormProvider>
			</Box>
		</MasterDialog>
	)
}
export default CourseForm
